<template>
  <vue-scroll>
    <rabbey-toolbox :call-new="callNew" />

    <RabbeyTable3
      :columns="columns"
      :data="items"
      style="margin: 20px"
      :actions="actions"
      @rtable-push-action="handlePushAction"
    />

    <el-drawer
      :title="tituloDrawer"
      :visible="openDetail"
      :size="sizedrawer"
      :before-close="CloseTransactionDetail"
    >
      <el-row :gutter="20" v-if="mostrardetalles">
        <el-col :offset="1">
          <h3>{{ textoTipo }}</h3>
          <span>{{ textoDescripcion }}</span>
        </el-col>
        <hr />
      </el-row>
      <el-form
        :model="IncomeForm"
        :rules="rules"
        ref="IncomeForm"
        label-width="120px"
        class="demo-ruleForm"
        :label-position="posionlabel"
        style="margin-left: 20px"
      >
        <el-row :gutter="20">
          <el-col :span="16"
            ><el-form-item :label="imputpreguntas" prop="types">
              <el-select
                v-model="IncomeForm.types"
                placeholder="Seleccione el tipo de ingresos"
              >
                <el-option
                  v-for="item in IncomesTypesoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="AFP">
              <el-switch
                v-model="IncomeForm.afp"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="SFS">
              <el-switch
                v-model="IncomeForm.sfs"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="ISR">
              <el-switch
                v-model="IncomeForm.isr"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="REGALIA">
              <el-switch
                v-model="IncomeForm.regalia"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="LIQUIDACION">
              <el-switch
                v-model="IncomeForm.liquidacion"
                active-color="#13ce66"
                inactive-color="#ff4949"
              >
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :offset="10"> </el-col>
          <el-col :span="20">
            <el-form-item label="Descripccion" v-if="mostrardescipccion">
              <el-input
                type="textarea"
                :rows="5"
                v-model="IncomeForm.description"
                width="3000px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :offset="17">
            <el-button
              type="primary"
              @click="manageIncomeType()"
              v-if="mostrarbotonSurvey"
              >{{ this.BotonManage }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-drawer>
  </vue-scroll>
</template>

<script>
// import { formatDate } from "../../utils";
import RabbeyTable3 from "@/components/RabbeyTable3.vue";
import RenderCheckLabelRequired from "@/components/functionals/RenderCheckLabelRequired.vue";
// import RenderCheckLabel from "@/components/functionals/RenderCheckLabel.vue";

export default {
  name: "IncomeTypes",
  components: {
    RabbeyTable3
    // RenderCheckLabel
    // RenderCheckLabelRequired
  },
  data() {
    return {
      IncomeForm: {
        id: 0,
        types: "",
        description: "",
        afp: false,
        sfs: false,
        isr: false,
        regalia: false,
        liquidacion: false
      },
      rules: {
        types: [
          {
            required: true,
            message: "Por favor Ingrese un tipo",
            trigger: "blur"
          }
        ]
      },
      items: [],
      mostrarselect: false,
      title: "Crear tipo de ingreso",
      drawer: false,
      isView: false,
      startedtime: false,
      isEdit: false,
      value1: true,
      mostrardetalles: true,
      // mostrartable: false,
      sizedrawer: "30%",
      id: 0,
      types: "",
      description: "",
      AFP: false,
      SFS: false,
      ISR: false,
      Regalia: false,
      Liquidacion: false,
      // viewselect:"inline-block",
      textoTipo: "",
      textoDescripcion: "",
      posionlabel: "",
      frecuencia: false,
      viewselect: false,
      mostrarbotonSurvey: false,
      mostarRequerido: true,
      mostrarEstatus: true,
      mostrartable: true,
      mostrarbotonquestion: false,
      checked: true,
      typebuttom: "el-icon-check",
      tituloDrawer: "Gestion de Preguntas ",
      openDetail: false,
      typerequest: 1,
      questionId: 0,
      No_Form: 0,
      mostrardescipccion: false,
      labelPosition: "right",
      mostrarselecttipo: true,
      imputpreguntas: "",
      itemsquestions: [],
      DescripccionEncuesta: "",
      IncomesTypesoptions: [
        {
          value: "Commision",
          label: "Comision"
        },
        {
          value: "Incentive",
          label: "Incentivos"
        },
        /*
        {
          value: "VacationalBonus",
          label: "Prima Vacacional"
        },
        */
        {
          value: "Salario_rectro",
          label: "Salario Rectroactivo"
        },
        {
          value: "DTrabajado",
          label: "Dias Trabajados"
        },
        {
          value: "Annual_Bonus",
          label: "Bonificacion Anual"
        },
        {
          value: "Other_Incomes",
          label: "Otros Ingresos"
        }
      ],
      columns: [
        {
          prop: "id",
          label: "id",
          fixed: true,
          minWidth: 100
        },
        {
          prop: "types",
          label: "Tipo",
          minWidth: 100
        },
        {
          prop: "description",
          label: "Descripcion",
          minWidth: 150
        },
        {
          prop: "AFP",
          label: "AFP",
          width: 100,
          formatter: RenderCheckLabelRequired
        },
        {
          prop: "SFS",
          label: "SFS",
          width: 100,
          formatter: RenderCheckLabelRequired
        },
        {
          prop: "ISR",
          label: "ISR",
          width: 100,
          formatter: RenderCheckLabelRequired
        },
        {
          prop: "Regalia",
          label: "Regalia",
          width: 100,
          formatter: RenderCheckLabelRequired
        },
        {
          prop: "Liquidacion",
          label: "Liquidacion",
          width: 100,
          formatter: RenderCheckLabelRequired
        }
      ],
      actions: [
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        },
        {
          label: "Eliminar",
          icon: "el-icon-delete",
          command: "delete"
        }
      ]
    };
  },
  computed: {
    params() {
      return {
        companyId: this.currentCompany
      };
    }
  },
  created() {
    this.getIncomesTypes();
  },
  methods: {
    resetForm1(formName) {
      this.$refs[formName].resetFields();
    },
    resetForm() {
      this.IncomeForm.id = 0;
      this.IncomeForm.types = "";
      this.IncomeForm.description = "";
      this.IncomeForm.afp = false;
      this.IncomeForm.sfs = false;
      this.IncomeForm.isr = false;
      this.IncomeForm.regalia = false;
      this.IncomeForm.liquidacion = false;
      this.isEdit = false;
    },
    CloseTransactionDetail() {
      this.openDetail = false;
      this.resetForm();
    },
    getIncomesTypes() {
      this.$http.get("/api/Payroll/GetIncomesTypesMaintenance").then((resp) => {
        this.items = resp.data;
      });
    },
    PostIncomeType() {
      const params = {
        typerequest: this.typerequest,
        types: this.IncomeForm.types,
        description: this.IncomeForm.description,
        AFP: this.IncomeForm.afp,
        SFS: this.IncomeForm.sfs,
        ISR: this.IncomeForm.isr,
        Regalia: this.IncomeForm.regalia,
        Liquidacion: this.IncomeForm.liquidacion
      };
      this.$refs["IncomeForm"].validate((valid) => {
        if (valid) {
          this.$http
            .post("/api/Payroll/InsertIncomesTypes", params)
            .then(() => {
              this.$message.success("Agregado correctamente");
              this.getIncomesTypes();
              this.resetForm();
              this.mostrardetalles = false;
              this.CloseTransactionDetail();
            });
        }
      });
    },
    async PutIncomeType() {
      const params = {
        id: this.IncomeForm.id,
        types: this.IncomeForm.types,
        description: this.IncomeForm.description,
        AFP: this.IncomeForm.afp,
        SFS: this.IncomeForm.sfs,
        ISR: this.IncomeForm.isr,
        Regalia: this.IncomeForm.regalia,
        Liquidacion: this.IncomeForm.liquidacion
      };
      this.$refs["IncomeForm"].validate((valid) => {
        if (valid) {
          this.$http.put("/api/Payroll/updateIncomesTypes", params).then(() => {
            this.$message.success("Agregado correctamente");
            this.getIncomesTypes();
            this.resetForm();
            this.mostrardetalles = false;
            this.CloseTransactionDetail();
          });
        }
      });
    },
    async DelIncomeTypes() {
      await this.$http
        .delete("/api/Payroll/deleteIncomesTypes?id=" + this.IncomeForm.id)
        .then(() => {
          this.$message.success("Eliminado correctamente");
          this.getIncomesTypes();
          this.resetForm();
          this.mostrardetalles = false;
          this.CloseTransactionDetail();
        })
        .catch(() => {
          this.$message.info("Error al eliminar");
        });
    },
    manageIncomeType() {
      if (this.isEdit == true) {
        this.PutIncomeType();
      } else {
        this.PostIncomeType();
      }
    },
    callNew() {
      this.startedtime = true;
      this.BotonManage = "Guardar";
      this.sizedrawer = "30%";
      this.tituloDrawer = "Crear tipo de ingreso";
      this.openDetail = true;
      this.mostrarTag = false;
      this.mostrarbotonquestion = false;
      this.isView = false;
      this.viewselect = false;
      this.mostrardetalles = false;
      this.posionlabel = "top";
      this.isEdit = false;
      this.imputpreguntas = "Tipo";
      this.drawer = true;
      this.mostrardescipccion = true;
      this.mostrarbotonSurvey = true;
      this.frecuencia = true;
    },
    handlePushAction(command) {
      // this.No_Form = command.row.No_Form;
      // this.No_FormReal = command.row.No_FormReal;
      // this.ruleForm.startedtime = command.row.StartDate;
      // this.ruleForm.status = command.row.IsEnable;
      switch (command.command) {
        case "view":
          this.isView = true;
          this.openDetail = true;
          break;

        case "edit":
          this.startedtime = true;
          this.BotonManage = "Editar";
          this.sizedrawer = "30%";
          this.tituloDrawer = "Editar tipo de ingreso";
          this.openDetail = true;
          this.mostrarTag = false;
          this.mostrarbotonquestion = false;
          this.isView = false;
          this.viewselect = false;
          this.mostrardetalles = false;
          this.posionlabel = "top";
          this.isEdit = true;
          this.imputpreguntas = "Tipo";
          this.drawer = true;
          this.mostrardescipccion = true;
          this.mostrarbotonSurvey = true;
          this.IncomeForm.id = command.row.id;
          this.IncomeForm.types = command.row.types;
          this.IncomeForm.description = command.row.description;
          this.IncomeForm.afp = command.row.AFP;
          this.IncomeForm.sfs = command.row.SFS;
          this.IncomeForm.isr = command.row.ISR;
          this.IncomeForm.regalia = command.row.Regalia;
          this.IncomeForm.liquidacion = command.row.Liquidacion;
          break;
        case "delete":
          this.IncomeForm.id = command.row.id;
          //console.log(command.row.id + this.IncomeForm.id);
          this.$confirm("Segura/o que desea eliminar este registro ?")
            .then(() => {
              this.DelIncomeTypes();
            })
            .catch(() => {
              this.$message.info("Eliminacion cancelada");
            });
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style>
.center-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5vh;
}

.centered-tag {
  font-size: 1em;
  /* Ajusta el tamaño del texto según tus necesidades */
  /* Estilos adicionales del tag si es necesario */
}

.custom-form .el-form-item__label {
  display: none;
  /* Oculta la etiqueta predeterminada */
}

.custom-form .custom-label {
  display: block;
  font-weight: bold;
  /* Otras propiedades de estilo según tus preferencias */
  margin-bottom: 8px;
  /* Ajusta el margen inferior según tus necesidades */
}

.el-form-item__label {
  font-weight: bold;
  /* Otras propiedades de estilo según tus preferencias */
}
</style>
